import { render, staticRenderFns } from "./TiLiangYuJi.vue?vue&type=template&id=552ce3d4&scoped=true&"
import script from "./TiLiangYuJi.vue?vue&type=script&lang=js&"
export * from "./TiLiangYuJi.vue?vue&type=script&lang=js&"
import style0 from "./TiLiangYuJi.vue?vue&type=style&index=0&id=552ce3d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ce3d4",
  null
  
)

export default component.exports